import { render } from "./APIReservations.vue?vue&type=template&id=343176bb&scoped=true&ts=true"
import script from "./APIReservations.vue?vue&type=script&lang=ts"
export * from "./APIReservations.vue?vue&type=script&lang=ts"

import "./APIReservations.vue?vue&type=style&index=0&id=343176bb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-343176bb"]])

export default __exports__